import { combineReducers } from "redux";

import customer from "./customerSlice";

export default combineReducers({ customer });
